import React from "react";

export const HazeIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="21" fillRule="nonzero" fill="#3F4447">
                <g transform="translate(4.000000, 23.000000)">
                    <path d="M2,23.5 L48,23.5 C48.8284271,23.5 49.5,22.8284271 49.5,22 C49.5,21.1715729 48.8284271,20.5 48,20.5 L2,20.5 C1.17157288,20.5 0.5,21.1715729 0.5,22 C0.5,22.8284271 1.17157288,23.5 2,23.5 Z" />
                    <path d="M53,23.5 L70,23.5 C70.8284271,23.5 71.5,22.8284271 71.5,22 C71.5,21.1715729 70.8284271,20.5 70,20.5 L53,20.5 C52.1715729,20.5 51.5,21.1715729 51.5,22 C51.5,22.8284271 52.1715729,23.5 53,23.5 Z" />
                    <path d="M8,33.5 L64,33.5 C64.8284271,33.5 65.5,32.8284271 65.5,32 C65.5,31.1715729 64.8284271,30.5 64,30.5 L8,30.5 C7.17157288,30.5 6.5,31.1715729 6.5,32 C6.5,32.8284271 7.17157288,33.5 8,33.5 Z" />
                    <path d="M2,3.5 L63,3.5 C63.8284271,3.5 64.5,2.82842712 64.5,2 C64.5,1.17157288 63.8284271,0.5 63,0.5 L2,0.5 C1.17157288,0.5 0.5,1.17157288 0.5,2 C0.5,2.82842712 1.17157288,3.5 2,3.5 Z" />
                    <path d="M20,13.5 L70,13.5 C70.8284271,13.5 71.5,12.8284271 71.5,12 C71.5,11.1715729 70.8284271,10.5 70,10.5 L20,10.5 C19.1715729,10.5 18.5,11.1715729 18.5,12 C18.5,12.8284271 19.1715729,13.5 20,13.5 Z" />
                </g>
            </g>
        </g>
    </svg>
);
